import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, Switch} from 'react-router-dom';
import Header from '../components/Header/header.jsx';
import Sidebar from '../components/Sidebar/sidebar.jsx';
import Footer from '../components/Footer/footer.jsx';
import AdminRoutes from '../routes/adminRoutes';
import UserRoutes from '../routes/userRoutes';
import GuestRoutes from '../routes/guestRoutes';
import CompanyAdminRoutes from '../routes/companyAdminRoutes';
import CompanyAdminRoutesAndOffers from '../routes/companyAdminRoutesAndOffers';
import OperatorRoutes from '../routes/operatorRoutes';
import DevRoutes from "../routes/devRoutes";
import {fetchCompanies} from '../actions/companyActions';
import {ACTIVE, COMPANY_ADMIN, DEVELOPER, GUEST, OPERATOR, SUPER_ADMIN, USER} from '../helpers/constants';
import {push} from "connected-react-router";
import {I18n} from '../I18n/layouts/layout.js';
import {getUserData, userLogout} from "../actions/authActions";
import PersonPackages from '../components/Person/PersonPackages/PersonPackages';
import CompaniesStat from '../components/Statistics/CompaniesStat/CompaniesStat.js';
import Users from "../components/Users/Users";
import CompanyStat from "../components/Statistics/CompanyStat/CompanyStat";
import {hasGeoActivityPermission, isStatisticPermission} from "../helpers/companyService";
import OfferStatPage from "../components/Promo/OfferStatPage/OfferStatPage";
import OperatorStatByCompanies from "../components/OperatorStat/OperatorStatByCompanies/OperatorStatByCompanies";
import swal from "sweetalert";
import OperatorUserRoutes from "../routes/operatorUserRoutes";
import TrackGeoActivity from "../components/Statistics/GeoActivity/TrackGeoActivity";

class Fulllayout extends Component {
	/*--------------------------------------------------------------------------------*/
	/*Change the layout settings [HEADER,SIDEBAR && DARK LAYOUT] from here            */
	/*--------------------------------------------------------------------------------*/
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			width: window.innerWidth,
			settings: [{
				theme: 'light',
				layout: 'vertical',
				dir: 'ltr',
				sidebartype: 'full',
				sidebarpos: 'fixed',
				headerpos: 'fixed',
				boxed: 'full',
				navbarbg: 'skin7',
				sidebarbg: 'skin5',
				logobg: 'skin7'
			}],
			isAuth: false,
		};

		//this.props.history.listen((location, action) => {
		// 	if (window.innerWidth < 767 &&
		// 		document.getElementById('main-wrapper').className.indexOf("show-sidebar") !== -1) {
		// 		document.getElementById('main-wrapper').classList.toggle("show-sidebar");
		// 	}
		//});

		this.updateDimensions = this.updateDimensions.bind(this);
	}
	/*--------------------------------------------------------------------------------*/
	/*Life Cycle Hook, Applies when loading or resizing App                           */
	/*--------------------------------------------------------------------------------*/
	componentDidMount() {
		console.log('mount layout');
		// 	window.addEventListener("load", this.updateDimensions);
		// 	window.addEventListener("resize", this.updateDimensions)
		(async () => {
			await this.props.getUserData();
			await this.logoutIfUserIsNotActive();
			if (this.props.currentUser && this.props.currentUser.defaultPassword) {
				this.props.changeLocation('/recover', {defaultPassword: true, email: this.props.currentUser.email})
			}
			//if (this.props.companies.length === 0) {
			//	await this.props.fetchCompanies();
			//}
		})()
	}
	/*--------------------------------------------------------------------------------*/
	/*Custom Functions                      										  */
	/*--------------------------------------------------------------------------------*/
	checkRoutesList = (routes) => {
		return (
			<Switch>
				{ routes.map((prop, key) => {
					if (prop.navlabel) {
						return null;
					}
					else if (prop.collapse) {
						return prop.child.map((prop2, key2) => {
							if (prop2.collapse) {
								return prop2.subchild.map((prop3, key3) => {
									return (
										<Route path={prop3.path} component={prop3.component} key={key3} exact={true}/>
									);
								});
							}
							return (
								<Route path={prop2.path} component={prop2.component} key={key2} exact={true}/>
							);
						});
					}
					else if (prop.redirect) {
						return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
					}
					else {
						return (
							<Route path={prop.path} component={prop.component} key={key} exact={true}/>
						);
					}
				})}

			</Switch>
		);
	};

	logoutIfUserIsNotActive = async () => {
        const {currentUser, lang} = this.props;
        if (currentUser.userStatus
			&& currentUser.userStatus !== ACTIVE) {
			this.props.userLogout();
			await swal(I18n[lang].userIsNotActive, "", "error")
				.then(() => this.props.changeLocation('/'));
		}
    }

	mainPageCheck = () => this.props.pathname === '/';

	renderGuestContent = () => {
		return !this.mainPageCheck() ? (
			<div></div>
		) : (
			<div>{I18n[this.props.lang].guest.title}</div>
		)
	};

	renderDevContent = () => {
		return !this.mainPageCheck() ? (
			<div></div>
		) : (
			<OfferStatPage />
		)
	};

	renderOperatorContent = () => {
		return !this.mainPageCheck() ? (
			<div></div>
		) : (
			<OperatorStatByCompanies />
		)
	};

	renderOperatorUserContent = () => {
		return <div></div>
	};

	renderUserContent = () => {
		const {authority, companies} = this.props;
		if (!this.mainPageCheck()) {
			return <div></div>;
		}
		if (hasGeoActivityPermission(companies[0], authority)) {
			return <TrackGeoActivity/>;
		}
		return <PersonPackages/>;
	};

	renderCompanyAdminContent = () => {
		if (!this.mainPageCheck())
			return null
		else if(isStatisticPermission(this.props.companies[0], this.props.authority))
			return (<CompanyStat />)
		else
			return (<Users />)
	};

	renderAdminContent = () => {
		return !this.mainPageCheck() ? (
			<div></div>
		) : (
			<CompaniesStat />
		)
	};

	/*--------------------------------------------------------------------------------*/
	/*Function that handles sidebar, changes when resizing App                        */
	/*--------------------------------------------------------------------------------*/
	updateDimensions() {
		let element = document.getElementById('main-wrapper');
		this.setState({
			width: window.innerWidth
		});
		if (element) {
			switch (this.state.settings[0].sidebartype) {
			case 'full':
			case 'iconbar':
				if (this.state.width < 1170) {
					element.setAttribute("data-sidebartype", "mini-sidebar");
					element.classList.add("mini-sidebar");
				} else {
					element.setAttribute("data-sidebartype", this.state.settings[0].sidebartype);
					element.classList.remove("mini-sidebar");
				}
				break;

			case 'overlay':
				if (this.state.width < 767) {
					element.setAttribute("data-sidebartype", "mini-sidebar");
				} else {
					element.setAttribute("data-sidebartype", this.state.settings[0].sidebartype);
				}
				break;

			default:
			}
		}
	}


	/*--------------------------------------------------------------------------------*/
	/*Life Cycle Hook                                                                 */
	/*--------------------------------------------------------------------------------*/
	componentWillUnmount() {
		window.removeEventListener("load", this.updateDimensions);
		window.removeEventListener("resize", this.updateDimensions);
	}

	checkRoutesForCompanyAdmin = () => {
		if (this.props.companies.length === 1) {
			if (this.props.companies[0].types.includes('DEVELOP')) {
				return this.checkRoutesList(DevRoutes);
			} else if (this.props.companies[0].types.includes('RETAIL')) {
				return this.checkRoutesList(CompanyAdminRoutes);
			} else if (this.props.companies[0].types.includes('OPERATOR')) {
				return this.checkRoutesList(OperatorRoutes);
			}
		} else if (this.props.companies[0].types.includes('DEVELOP') &&
			this.props.companies[0].types.includes('RETAIL')) {
			return this.checkRoutesList(CompanyAdminRoutesAndOffers);
		}
	}

	checkRoutesForUser = () => {
        if (this.props.companies.length === 1
            && this.props.companies[0].types.includes('OPERATOR')) {
            return this.checkRoutesList(OperatorUserRoutes);
        }
        return this.checkRoutesList(UserRoutes);
    }

	checkRoutes = authority => {
		switch(authority) {
			case GUEST:
				return this.checkRoutesList(GuestRoutes);
			case USER:
				return this.checkRoutesForUser();
			case COMPANY_ADMIN:
				return this.checkRoutesForCompanyAdmin();
			case SUPER_ADMIN:
				return this.checkRoutesList(AdminRoutes);
			default:
				return this.checkRoutesList(GuestRoutes);
		}
	}

	selectRoutes = () => {
		if (this.props.companies.length === 1) {
			if (this.props.companies[0].types.includes('DEVELOP')) {
				return DevRoutes;
			} else if (this.props.companies[0].types.includes('RETAIL')) {
				return CompanyAdminRoutes;
			} else if (this.props.companies[0].types.includes('OPERATOR')) {
				return OperatorRoutes;
			}
		} else if (this.props.companies[0].types.includes('DEVELOP') &&
			this.props.companies[0].types.includes('RETAIL')) {
			return CompanyAdminRoutesAndOffers;
		}
	}

    selectUserRoutes = () => {
		if (this.props.companies.length === 1
			&& this.props.companies[0].types.includes('OPERATOR')) {
			return OperatorUserRoutes;
		}
		return UserRoutes;
	}

	renderContent = authority => {
		switch (authority) {
			case USER:
				if (this.props.companies.length === 1
					&& this.props.companies[0].types.includes('OPERATOR')) {
					return this.renderOperatorUserContent()
				}
				return this.renderUserContent();
			case COMPANY_ADMIN:
                if (this.props.companies.length === 1) {
                    if (this.props.companies[0].types.includes('DEVELOP')) {
                        return this.renderDevContent();
                    } else if (this.props.companies[0].types.includes('RETAIL')) {
						return this.renderCompanyAdminContent();
                    } else if (this.props.companies[0].types.includes('OPERATOR')) {
						return this.renderOperatorContent()
                    }
                }
				return this.renderCompanyAdminContent();
			case SUPER_ADMIN:
				return this.renderAdminContent();
			case DEVELOPER:
				return this.renderDevContent();
			case GUEST:
			default:
				return this.renderGuestContent();
		}
	}

	render() {
		console.log('render layout', this.props.currentUser);
		const {
			authority,
		} = this.props;
		window.addEventListener("load", this.updateDimensions);
		window.addEventListener("resize", this.updateDimensions);
		/*--------------------------------------------------------------------------------*/
		/* Theme Setting && Layout Options wiil be Change From Here                       */
		/*--------------------------------------------------------------------------------*/
		if (!authority) {
			return (
				<div>...Loading</div>
			)
		}
		if ( this.props.companies.length === 0 ) {
			return (
				<div>Server error. Please reload the page!</div>
			)
		}
		return (
			<div
				id="main-wrapper"
				dir={this.state.settings[0].dir}
				data-theme={this.state.settings[0].theme}
				data-layout={this.state.settings[0].layout}
				data-sidebartype={this.state.settings[0].sidebartype}
				data-sidebar-position={this.state.settings[0].sidebarpos}
				data-header-position={this.state.settings[0].headerpos}
				data-boxed-layout={this.state.settings[0].boxed}
			>
				{/*--------------------------------------------------------------------------------*/}
				{/* Header                                                                         */}
				{/*--------------------------------------------------------------------------------*/}
				<Header data={this.state} {...this.props}/>
				{/*--------------------------------------------------------------------------------*/}
				{/* Sidebar                                                                        */}
				{/*--------------------------------------------------------------------------------*/}
				{
					// (authority !== GUEST) ? (
					// 	<Sidebar data={this.state} {...this.props} routes={AdminRoutes} />
					// ) : (
					// 	<Sidebar data={this.state} {...this.props} routes={UserRoutes} />
					// )
					(() => {
						switch(authority) {
							case GUEST :
								{
									return <Sidebar
										data={this.state}
										{...this.props}
										lang={this.props.lang}
										routes={GuestRoutes}
									/>
								}
							case USER :
								{
									return <Sidebar
										data={this.state}
										{...this.props}
										lang={this.props.lang}
										routes={this.selectUserRoutes()}
									/>
								}
							case COMPANY_ADMIN :
							{
								return <Sidebar
									data={this.state}
									{...this.props}
									lang={this.props.lang}
									routes={this.selectRoutes()}
								/>
							}
							case SUPER_ADMIN :
							{
								return <Sidebar data={this.state} {...this.props} lang={this.props.lang} routes={AdminRoutes}/>
							}
							default : {
								return <Sidebar data={this.state} {...this.props} lang={this.props.lang} routes={GuestRoutes}/>
							}
						}
					})()
				}
				{/*--------------------------------------------------------------------------------*/}
				{/* Page Main-Content                                                              */}
				{/*--------------------------------------------------------------------------------*/}
				<div className="page-wrapper d-block">
					<div className="page-content container-fluid" style={{position: "relative"}}>
						{this.renderContent(authority)}
						{this.checkRoutes(authority)}
					</div>
					<Footer />
				</div>
			</div>
		);
	}
}
const mapDispatchToProps = (dispatch) => {
	return ({
		fetchCompanies: query => dispatch(fetchCompanies(query)),
		changeLocation: (url, data) => dispatch(push(url, data)),
		getUserData: () => dispatch(getUserData),
		userLogout: () => dispatch(userLogout())
	});
};

const mapStateToProps = state => {
	return ({
		//isLoading: state.itemsIsLoading,
		isAuth: state.isAuth,
		currentUser: state.currentUser,
		authority: state.isAuth && state.currentUser ? state.currentUser.roles[0].authority : GUEST,
		pathname: state.router.location.pathname,
		companies: state.companiesReducer.companies,
		lang: state.languageReducer.lang
	})
};

export default connect(mapStateToProps, mapDispatchToProps)(Fulllayout);



// WEBPACK FOOTER //
// ./src/layouts/fulllayout.jsx